module.exports = __webpack_public_path__ + "static/img/l_wlcysx.ab0a4702.png";